import { StudentExamType } from '../../api/student-exam';
import Field from '../shared/field';
import Segment from '../shared/segment';
import Section from '../shared/section';
import NavLink from '../shared/buttons/nav-link';

export type StuedentExamPropsType = {
  studentExam: StudentExamType;
};

function StudentExam({ studentExam }: StuedentExamPropsType) {
  const studentCountIsUpdating = !studentExam.exam.expired || !studentExam.exam.isExpired;

  return (
    <Segment
      hoverable
      noPad
      color={studentExam.status === 2 ? 'green' : 'yellow'}
      rounded='lg'
      className='flex flex-col'
    >
      <Section>
        <p className='text-center font-medium'>{studentExam.exam.name}</p>
      </Section>
      <Section className='flex flex-col gap-2'>
        <Field title='تعداد سوالات' content={studentExam.exam.questionCount} />
        <Field title='زمان آزمون' content={`${studentExam.exam.duration} دقیقه`} />
        <Field title='نمره منفی' content={studentExam.exam.penalty ? 'دارد' : 'ندارد'} />
      </Section>
      <Section className='flex flex-col gap-2'>
        <Field title='وضعیت' content={studentExam.status === 2 ? 'شرکت کرده' : 'منقضی شده'} />
        <p>
          <span className='font-medium'>تعداد شرکت‌کنندگان </span>
          {studentCountIsUpdating ? (
            <span className='font-medium text-red-500'>تا این لحظه</span>
          ) : (
            <span className='font-medium'>نهایی</span>
          )}
          <span className='font-medium'>: </span>{' '}
          <span>{studentExam.exam.studentFinishedCount}</span>
        </p>
      </Section>
      <div className='my-4 mx-auto flex gap-2 text-center'>
        {studentExam.status === 2 && (
          <NavLink
            to={`/exams/${studentExam.exam.id}/report`}
            color='blue'
            content='کارنامه'
            className='mx-auto'
          />
        )}
        {(studentExam.exam.analysis || !studentExam.exam.expired || studentExam.exam.isExpired) && (
          <NavLink
            to={`/exams/${studentExam.exam.id}/review`}
            color='green'
            content='تحلیل'
            className='mx-auto'
          />
        )}
        {(!studentExam.exam.expired || studentExam.exam.isExpired) && (
          <NavLink
            to={`/exams/${studentExam.exam.id}/ranking`}
            color='indigo'
            content='رتبه‌بندی'
            className='mx-auto'
          />
        )}
      </div>
    </Segment>
  );
}

export default StudentExam;
